/* ========================================================================
 * DOM-based Routing
 * Based on http://goo.gl/EUTi53 by Paul Irish
 *
 * Only fires on body classes that match. If a body class contains a dash,
 * replace the dash with an underscore when adding it to the object below.
 *
 * .noConflict()
 * The routing is enclosed within an anonymous function so that you can
 * always reference jQuery with $, even when in .noConflict() mode.
 * ======================================================================== */

( function( app ) {
  const COMPONENT = {

    // Inputs
    inputLoanPurpose: $( 'input[name="loan_purpose"]:checked' ),
    inputZipCode: $( 'input[name="zip_code"]' ),
    inputState: $( 'select[name="state"]' ),
    inputCounty: $( 'select[name="county"]' ),
    inputPurchasePrice: $( 'input[name="purchase_price"]' ),
    inputDownPaymentPercent: $( 'input[name="down_payment_percent"]' ),
    inputDownPaymentAmount: $( 'input[name="down_payment_amount"]' ),
    inputLoanAmount: $( 'input[name="loan_amount"]' ),
    inputCreditScore: $( 'select[name="credit_score"]' ),
    inputOccupancy: $( 'select[name="occupancy"]' ),
    inputPropertyType: $( 'select[name="property_type"]' ),
    inputLoanProgram: $( 'select[name="loan_program"]' ),
    inputDisplayVARates: $( 'select[name="display_va_rates"]' ),
    inputDisplayFHARates: $( 'select[name="display_fha_rates"]' ),
    // Buttons
    buttonSubmit: $( 'button[name="mortgage_rates_submit"]' ),
    // Variables
    errors: [],

    init: function() {
      const _this = this;

      $( '.mortgage-rates__tooltip' ).hover(
          function() {
            $( this ).find( '.mortgage-rates__tooltip-popup' ).addClass( 'is-visible' );
          },
          function() {
            $( this ).find( '.mortgage-rates__tooltip-popup' ).removeClass( 'is-visible' );
          }
      );

      _this.buttonSubmit.click( function() {
        _this.submitMortgageRatesForm();
      } );
      const state = document.getElementById( 'state' );
      if ( state.length > 0 ) {
        const selectElement = document.getElementById( 'county' );
        selectElement.setAttribute( 'disabled', true );
        const options = document.querySelectorAll( '#county option' ).forEach( ( option ) => option.remove() );
        _this.fetchCounties( state.options[state.selectedIndex].text );
      }
      _this.inputState.change( function( e ) {
        const selectElement = document.getElementById( 'county' );
        selectElement.setAttribute( 'disabled', true );
        const options = document.querySelectorAll( '#county option' ).forEach( ( option ) => option.remove() );
        _this.fetchCounties( e.target.options[e.target.selectedIndex].text );
      } );
      _this.inputDownPaymentPercent.change( function() {
        _this.calculateDownPayment( 'percent' );
      } );
      _this.inputDownPaymentAmount.change( function() {
        _this.calculateDownPayment( 'amount' );
      } );
      _this.inputPurchasePrice.change( function() {
        _this.calculateDownPayment( false );
      } );
      _this.inputLoanAmount.change( function() {
        _this.calculateDownPayment( 'loan_amount' );
      } );
      $( 'input[name="loan_purpose"]' ).change( function() {
        _this.inputLoanPurpose = $( this );
        if ( $( this ).val() === '0' ) {
          $( 'label[for="purchase_price"]' ).text( 'Purchase Price' );
          _this.inputDownPaymentAmount.removeAttr( 'disabled' );
          _this.inputDownPaymentPercent.removeAttr( 'disabled' );
        } else {
          $( 'label[for="purchase_price"]' ).text( 'Property Value' );
          _this.inputDownPaymentAmount.val( '' ).attr( 'disabled', 'disabled' );
          _this.inputDownPaymentPercent.val( '' ).attr( 'disabled', 'disabled' );
        }
      } );

      _this.inputDisplayVARates.change( function() {
        if ( _this.inputDisplayVARates.val() === 'Yes' ) {
          _this.inputDisplayFHARates.attr( 'disabled', 'disabled' ).val( 'No' );
        } else {
          _this.inputDisplayFHARates.removeAttr( 'disabled' );
        }
      } );

      _this.inputDisplayFHARates.change( function() {
        if ( _this.inputDisplayFHARates.val() === 'Yes' ) {
          _this.inputDisplayVARates.attr( 'disabled', 'disabled' ).val( 'No' );
        } else {
          _this.inputDisplayVARates.removeAttr( 'disabled' );
        }
      } );
    },

    finalize: function() {
    },

    logInputs: function() {
      const _this = this;
      console.log( 'Mortgage Rates:' );
      console.log( 'Loan Purpose: ' + _this.inputLoanPurpose.val() );
      console.log( 'Zip Code: ' + _this.inputZipCode.val() );
      console.log( 'City State: ' + _this.inputState.val() );
      console.log( 'Purchase Price: ' + _this.inputPurchasePrice.val() );
      console.log( 'Down Payment Percent: ' + _this.inputDownPaymentPercent.val() );
      console.log( 'Down Payment Amount: ' + _this.inputDownPaymentAmount.val() );
      console.log( 'Loan Amount: ' + _this.inputLoanAmount.val() );
      console.log( 'Credit Score: ' + _this.inputCreditScore.val() );
      console.log( 'Occupancy: ' + _this.inputOccupancy.val() );
      console.log( 'Property Type: ' + _this.inputPropertyType.val() );
      console.log( 'Loan Program: ' + _this.inputLoanProgram.val() );
      console.log( 'Display VA Rates: ' + _this.inputDisplayVARates.val() );
      console.log( 'Display FHA Rates: ' + _this.inputDisplayFHARates.val() );
      console.log( '-----' );
    },

    fetchCounties: function( state ) {
      const _this = this;
      const selectElement = document.getElementById( 'county' );
      $.post(
          site_info.ajax_url,
          {
            action: 'll_run_function',
            function: 'll_fetch_counties',
            params: {
              state: state,
            },
          },
          function( response, textStatus, xhr ) {
            response = $.parseJSON( response );
            if ( response.status === 'success' ) {
              counties = response.response.counties;

              if ( counties.length > 0 ) {
                for ( const item of counties ) {
                  selectElement.add( new Option( item.name, item.county ) );
                }
                selectElement.removeAttribute( 'disabled' );
              }
            }
          } );
    },

    calculateDownPayment: function( downPaymentChanged ) {
      const _this = this;

      if ( _this.inputLoanPurpose.val() === '0' ) {
        if ( _this.inputPurchasePrice.val().length ) {
          if ( _this.inputDownPaymentPercent.val().length && ( downPaymentChanged === 'percent' || ! downPaymentChanged ) ) {
            _this.inputDownPaymentAmount.val( parseInt( _this.inputPurchasePrice.val() * ( _this.inputDownPaymentPercent.val() / 100 ) ) );
          } else if ( _this.inputDownPaymentAmount.val().length && downPaymentChanged === 'amount' ) {
            _this.inputDownPaymentPercent.val( parseFloat( _this.inputDownPaymentAmount.val() / _this.inputPurchasePrice.val() * 100 ).toFixed( 2 ) );
          } else if ( _this.inputLoanAmount.val() && _this.inputPurchasePrice.val() && downPaymentChanged === 'loan_amount' ) {
            const percentage = parseFloat( ( _this.inputPurchasePrice.val() - _this.inputLoanAmount.val() ) / _this.inputPurchasePrice.val() * 100 );
            _this.inputDownPaymentPercent.val( percentage.toFixed( 2 ) );
            _this.inputDownPaymentAmount.val( parseInt( _this.inputPurchasePrice.val() - _this.inputLoanAmount.val() ) );
          }

          if ( _this.inputDownPaymentAmount.val() && downPaymentChanged !== 'loan_amount' ) {
            _this.inputLoanAmount.val( parseInt( _this.inputPurchasePrice.val() - _this.inputDownPaymentAmount.val() ) );
          }
        }
      }
    },

    submitMortgageRatesForm: function() {
      const _this = this;
      // _this.logInputs();

      // Validate fields
      _this.errors = _this.validateInputs();
      $( '#mortgage-rates-form-errors' ).html( '' );
      $( '#mortgage-rates-form-errors' ).addClass( 'hidden' );

      if ( _this.errors.length ) {
        // If any errors, display them
        $( '#mortgage-rates-form-errors' ).removeClass( 'hidden' );
        // console.log( 'Errors:' );
        $.each( _this.errors, function( index, error ) {
          // console.log( error );
          $( '#mortgage-rates-form-errors' ).append( '<p>' + error + '<p>' );
        } );
        // console.log( '-----' );
      } else {
        // No errors, get rates
        $( '.mortgage-rates__table tbody' ).html( '' );
        $( '.mortgage-rates__results' ).addClass( 'hidden' );
        $( '.mortgage-rates__table-error' ).addClass( 'hidden' );
        $( '.mortgage-rates' ).addClass( 'is-loading' );

        $url = $( '.append-rates-data' ).attr( 'href' );

        $newUrl = $url + '?zip_code=' + _this.inputZipCode.val() + '&purchase_price=' + _this.inputPurchasePrice.val() + '&down_payment_percent=' + _this.inputDownPaymentPercent.val() + '&down_payment_dollars=' + _this.inputDownPaymentAmount.val() + '&loan_amount=' + _this.inputLoanAmount.val() + '&credit_score=' + _this.inputCreditScore.val() + '&occupancy=' + _this.inputOccupancy.val() + '&property_type=' + _this.inputPropertyType.val() + '&loan_program=' + _this.inputLoanProgram.val() + '&military_veteran=' + _this.inputDisplayVARates.val() + '&display_fha_rates=' + _this.inputDisplayFHARates.val();

        $( '.append-rates-data' ).attr( 'href', $newUrl );

        let filterId = 'CONVWEB';
        let isFHAorVA = false;

        if ( _this.inputDisplayVARates.val() === 'Yes' ) {
          filterId = 'VAWEB';
          leadSource = 1004;
          isFHAorVA = true;
        }

        if ( _this.inputDisplayFHARates.val() === 'Yes' ) {
          filterId = 'FHAWEB';
          leadSource = 1004;
          isFHAorVA = true;
        }

        if ( filterId === 'CONVWEB' && _this.inputLoanAmount.val() >= 647200 ) {
          leadSource = 1004;
        } else {
          leadSource = 1004;
        }

        const custId = '17biso01';
        const partnerId = '97';
        const currentTime = +new Date(); // the current time in milliseconds
        const issuedAtTimeSeconds = currentTime/1000;
        const expirationTimeSeconds = currentTime/1000 + 3600;

        const header = {'alg': 'RS256', 'typ': 'JWT'};
        const payload = {
          'customerId': custId,
          'partnerId': partnerId,
          'iat': Math.ceil( issuedAtTimeSeconds ),
        };

        const privateKey = `-----BEGIN PRIVATE KEY-----
        MIIEvQIBADANBgkqhkiG9w0BAQEFAASCBKcwggSjAgEAAoIBAQDKebf3v51LUj1P
        9QjoxXd7eiAF/rcsgA2U8xPsXLbd6apdZYIT8W4jkfUBBWFaFlLC2FdhNpy9x0gY
        Ko7AFzHJlk2PU6LKWDDF/lkbKNL8UWMYKmv2HuRgsK0CWVwtCcjdE7ZnTpdd0dC8
        czvBZ+Ta21VnhkUUobhbh1MF4PYNj0dlaElDXZbWL96UKaVWZMwWhgiDqbdpgpSN
        vx3yYYR0muZTf6dONZQQQAU5oh2mJlakMFwSH61nPzCP4JQYxKTtDCa/VlXZt1ZF
        AZA3THAJ1jDmUQF/h35zlt1SPhVyQk2Cvz6s5/zm/Sp7Y8x3cTdr9rE1/QNCkxuZ
        CqUdSZDzAgMBAAECggEAVyUiQBiRq6x+xR4ysnTjIxsCE3J5BkcrEVO53H5fGo4K
        jF43KTw9akPUzpaxOuPmxQP2P9oQhkHyTqxqelTBUgFF6o1VwH9Kprz9PwpIHN8u
        pmUDyI+tPcxs+ljZqmzOrhBg7n/N+Exo6eMy8eA0iNnkHUWWD/Y28fYBjsMvQ9AF
        zEzPsxnbZ4L7UotZUUjiJ5oUNoZm7Zp8SZ6P8Gl/BwwmqvyiLDc6e/iFy68RyGOs
        BPNfRpSQqeRPY93jOx5OIaT5TX7QBmbVV1fwSBODEmqc8aG9FVsr6M2NJWSHbV6c
        Qzf6vxh9MtWCQ7ZImzlpRUl8OlBKcUChOJ3RCMEEQQKBgQDyh63o71KF9Mkw24XG
        vhX5KO84Mir5uf4mnwepkAdWOcQ23Tfg4T0k9sMboBt0SDuHLA+oZiIspwTeUrrp
        2eWSS2NSgMIrkbDtHorqjOU1RLK6hehsbm/ZqWnH4mUYv5c+vjqaHEpnJI6JCWmz
        vUKGf9UadHXowH5E5WkFKDw04QKBgQDVuIoC9SkAlgz1BlTku8YvMmrl1y8+BE7y
        a2RHfuaRzd1Elalf1/z5fnlPwS3jKDrfgnF+Ad3V2/atUlPSzhv4B+fzlCvVpd6k
        oZUsHSQRTbakCNbh8lm2fNsDGGWCPVYe+CzYH6W9ztK+leJ/KSkfiAvBy4iab2TN
        CKTG/KXsUwKBgAqWa7wofnTEm+fbHXrwn2ryI4dTgVbHjNXIyX/Yfsl/2hX/EEpr
        6sxrTVcuZSRtZtPe04wpcUJ7xBWkjO5aidAaJGrcnh1izdN8KtpUbkkmB5tm7x+U
        rqNU5v5H3tv2uTaO/WXu6DyadvJ6i7fCAl52xCnUfbU8egat8Si9eethAoGBALAK
        BzQUeCeRcS7KflbCDKaHouGa88Djj5vCtaDmeEkVBvMdS5w0rp1bfdUhzAhV9Nhx
        +8XNB8rGGlP9giobt5IAASDzpX+f1tpIdjUV88WE+7H1zfniw966zTOpfsNefneX
        +Gg0+TJ1D8YIc75GSyc7ymNgoS6EHsV8Hy4AoTMdAoGARJhjGjURUkax/mLgSA/Y
        Z3bivIm3SBB9QO0TCDgPBHX7kgfRypuGI9nFXEzEmOK3yuPvpbx+zHaH6ElbRnKH
        p9dt0m1T8svjfuN7eB+9TzpuXcXcuQOpkgVGbH6GlOO9Bpd3EA3OKgNNpeVdknJI
        pw0uJC06brHNLk9Ghl0kkUo=
        -----END PRIVATE KEY-----`;

        // console.log( privateKey );
        const sHeader = JSON.stringify( header );
        const sPayload = JSON.stringify( payload );

        const sJWT = KJUR.jws.JWS.sign( header.alg, sHeader, sPayload, privateKey );

        const signedJWT = sJWT;

        const data = {
          'request_id': 1,
          'customerId': '17biso01',
          'thirdPartyName': 'liftedlogic',
          'emailAddress': 'info@fmdloans.com',
          'loan_amount': _this.inputLoanAmount.val(),
          'loanProduct1': _this.inputLoanProgram.val(),
          'appraisedvalue': _this.inputPurchasePrice.val(),
          'downPayment': _this.inputDownPaymentAmount.val(),
          'fico': _this.inputCreditScore.val(),
          'loanpurpose': _this.inputLoanPurpose.val(),
          'propertyState': _this.inputState.val(),
          'propertyCounty': _this.inputCounty.val(),
          'propertyZip': _this.inputZipCode.val(),
          'occupancy': _this.inputOccupancy.val(),
          'proptype': _this.inputPropertyType.val(),
          'pmiCompany': -999,
          'noMI': 0,
          'leadSource': leadSource, // 10022
          'filterId': filterId,
          'DTIPercent': 45,
          'lockindays': 30,
        };
        // console.log( data );
        if ( isFHAorVA ) {
          data.financeMI = 1;
        }

        $.post(
            site_info.ajax_url,
            {
              action: 'll_run_function',
              function: 'll_add_authorize_jwt',
              params: {
                signed_jwt: signedJWT,
                data: data,
              },
            },
            function( response, textStatus, xhr ) {
              response = $.parseJSON( response );
              // console.log( response.response.response );
              if ( response.status === 'success' ) {
                // sorry.sorry.sorry
                const results = $( response.response.response ).find( 'results' );
                // console.log( results );
                $( '.mortgage-rates' ).removeClass( 'is-loading' );
                if ( results.length ) {
                  $( '.mortgage-rates__results' ).removeClass( 'hidden' );

                  // After response, display rates
                  let html = ``;

                  results.each( function( index, result ) {
                    // console.log( result );
                    const quoteDetail = $( result ).find( 'quote_detail' );

                    const piti = parseFloat( quoteDetail.attr( 'piti' ) );
                    const monthlyPremium = parseFloat( quoteDetail.attr( 'monthlyPremium' ) ).toFixed( 2 ).replace( '.00', '' );
                    const monthlyPayment = parseFloat( piti - monthlyPremium ).toFixed( 2 ).replace( '.00', '' );

                    let feeTotal = 0;
                    // const branchProfit = $( result ).find( 'branch_profit' );
                    // const overParAddlProfit = $( result ).find( 'over_par_addl_profit' );
                    const overParProfit = $( result ).find( 'over_par_profit' );
                    // const costsAndProfit = $( result ).find( 'costs_and_profit' );
                    const amtFromBorrower = $( result ).find( 'amt_from_borrower' );
                    // const borrowerRebate = $( result ).find( 'borrowerRebate' );
                    // const costsDetail = $( result ).find( 'costs_detail' );

                    // const fees = $( result ).find( 'fee' );
                    // if ( fees.length ) {
                    //   $.each( fees, function( index, fee ) {
                    //     feeTotal += parseFloat( $( fee ).attr( 'feeamount' ) );
                    //   } );
                    // }

                    // if ( branchProfit.length ) {
                    //   feeTotal += parseFloat( parseFloat( branchProfit.attr( 'profit_percent' ) ) / 100 * _this.inputLoanAmount.val() ); // Loan Amount * Profit Percent
                    //   feeTotal += parseFloat( branchProfit.attr( 'profit_dollar' ) ); // Add Branch Profit Dollar
                    // }
                    // if ( overParAddlProfit.length ) {
                    //   feeTotal += parseFloat( overParAddlProfit.attr( 'profit_dollar' ) ); // Add Over Par Addl Profit Dollar
                    // }
                    if ( overParProfit.length ) {
                      feeTotal -= parseFloat( overParProfit.attr( 'profit_dollar' ) ); // Add Over Par Profit Dollar
                    }
                    if ( amtFromBorrower.length ) {
                      feeTotal += parseFloat( amtFromBorrower.attr( 'profit_dollar' ) ); // Add Amount from Borrower
                    }
                    // if ( costsAndProfit.length ) {
                    //   feeTotal -= parseFloat( costsAndProfit.attr( 'total_cost_profit_dollar' ) ); // Remove Total Cost Profit Dollar
                    // }

                    // if ( borrowerRebate.length ) {
                    //   feeTotal += parseFloat( $( borrowerRebate ).text() ); // Remove Borrower Rebate
                    // }

                    // if ( _this.inputDisplayVARates.val() === 'Yes' ) {
                    //   feeTotal += parseFloat( $( costsDetail ).attr( 'total_costs_dollar' ) ); // Remove Borrower Rebate
                    // }


                    let points = parseFloat( parseFloat( feeTotal * 100 ) / parseFloat( _this.inputLoanAmount.val() ) ).toFixed( 3 );
                    if ( points < 0 ) {
                      points = parseFloat( 0 ).toFixed( 3 );
                    }

                    let feeTotalDisplay = '';
                    if ( feeTotal < 0 ) {
                      feeTotalDisplay = '-$' + Math.abs( feeTotal );
                    } else {
                      feeTotalDisplay = '$' + feeTotal;
                    }

                    feeTotal = feeTotal.toFixed( 2 ).replace( '.00', '' );
                    index = index + 1;
                    $newUrl1 = '';
                    $newUrl2 = '';
                    $newUrl3 = '';
                    if ( index == 1 ) {
                      $newUrl1 = `&rate_${index}=${quoteDetail.attr( 'rate' )}&apr_${index}=${quoteDetail.attr( 'apr' )}&principal_interest_${index}=${monthlyPayment}&mortgage_insurance_${index}=${monthlyPremium}&points_credit_${index}=${points}&lender_fees_${index}=${feeTotalDisplay}`;
                    }
                    if ( index == 2 ) {
                      $newUrl2 = `&rate_${index}=${quoteDetail.attr( 'rate' )}&apr_${index}=${quoteDetail.attr( 'apr' )}&principal_interest_${index}=${monthlyPayment}&mortgage_insurance_${index}=${monthlyPremium}&points_credit_${index}=${points}&lender_fees_${index}=${feeTotalDisplay}`;
                    }
                    if ( index == 3 ) {
                      $newUrl3 = `&rate_${index}=${quoteDetail.attr( 'rate' )}&apr_${index}=${quoteDetail.attr( 'apr' )}&principal_interest_${index}=${monthlyPayment}&mortgage_insurance_${index}=${monthlyPremium}&points_credit_${index}=${points}&lender_fees_${index}=${feeTotalDisplay}`;
                    }

                    html += `
                                    <tr>
                                      <td class="rate-${index}">${quoteDetail.attr( 'rate' )}%</td>
                                      <td class="api-${index}">${quoteDetail.attr( 'apr' )}%</td>
                                      <td class="principal-interest-${index}">$${monthlyPayment}</td>
                                      <td class="mortgage-insurance-${index}">$${monthlyPremium}</td>
                                      <td class="points-credit-${index}">${points}</td>
                                      <td class="lender-fees-${index}">${feeTotalDisplay}</td>
                                      <td><a href="https://idp.elliemae.com/authorize?client_id=srtrz0d2&site_id=4399980613&response_type=code&redirect_uri=https%3A%2F%2Ffmdloans.mymortgage-online.com%2Fborrower-app%2Flogin%2F%3FworkFlowId%3D62997%26%26guestuser%3D1%26dest%3D%2Floan-app%2F%26siteId%3D4399980613&scope=ccbp%20cc&instance_id=be11137883&logo_url=https%3A%2F%2Fasset-service-bucket-prod.s3.us-west-2.amazonaws.com%2F47979db2-acf2-4475-add1-97cc4875eb9b&logo_url_href=http%3A%2F%2Ffmdloans.com&logo_alt_text=FMD%20Loans&bust=769&apiBaseUrl=https://api.elliemae.com" class="btn--alt next-steps p-0">Next Steps</a></td>
                                    </tr>
                                    `;
                  } );

                  $url = $( '.append-rates-data' ).attr( 'href' );

                  $newUrl = $url + $newUrl1 + $newUrl2 + $newUrl3;

                  $( '.mortgage-rates__table tbody' ).html( html );
                  $( '.append-rates-data' ).attr( 'href', $newUrl );
                  $( '.next-steps' ).attr( 'href', $newUrl );
                } else {
                  $( '.mortgage-rates__table-error' ).removeClass( 'hidden' );
                }
              }
            } );
      }
    },

    validateInputs: function() {
      const _this = this;
      const errorsArray = [];

      if ( ! _this.inputZipCode.val().length ) {
        errorsArray.push( 'Please enter a Zip Code' );
      } else {
        const isValidZip = /(^\d{5}$)|(^\d{5}-\d{4}$)/.test( _this.inputZipCode.val() );
        if ( ! isValidZip ) {
          errorsArray.push( 'Please enter a valid Zip Code.' );
        }
      }
      //
      if ( ! _this.inputState.val().length ) {
        errorsArray.push( 'Please select a State.' );
      }

      if ( ! _this.inputPurchasePrice.val().length ) {
        errorsArray.push( 'Please enter a Purchase Price.' );
      }

      if ( _this.inputLoanPurpose.val() === '0' ) {
        if ( ! _this.inputDownPaymentPercent.val().length || ! _this.inputDownPaymentAmount.val().length ) {
          errorsArray.push( 'Please enter a Down Payment Amount or Percent.' );
        }
      }

      if ( ! _this.inputLoanAmount.val().length ) {
        errorsArray.push( 'Please enter a Loan Amount.' );
      }

      return errorsArray;
    },
  };

  app.registerComponent( 'mortgage-rates', COMPONENT );
} )( app );
